{
  "ja": {
    "js": {
      "format": {
        "search_condition": "検索条件：%{search_condition}"
      },
      "common": {
        "word": "文字",
        "explanation_for_AND_search": "AND検索:選択したすべての条件を満たす求職者を検索します"
      },
      "resumes": {
        "about_status": "ステータスに関するご説明は<a href='https://jinzai-draft-cl.zendesk.com/hc/ja/articles/6507585448089' target='_blank'>こちら</a>"
      },
      "password": {
        "strengthTitle": "パスワードの強度：",
        "hasWeaknesses": "あなたのパスワードをより強固にするために",
        "tooShort": "少なくとも6文字以上にしてください",
        "addLowerCase": "小文字を追加してください",
        "addUpperCase": "大文字を追加",
        "addNumbers": "番号を追加",
        "addPunctuation": "記号を追加",
        "sameAsUsername": "ユーザー名と同じにしないでください",
        "confirmSuccess": "はい",
        "confirmFailure": "いいえ",
        "weak": "弱い",
        "fair": "適正",
        "good": "良い",
        "strong": "強",
        "confirmTitle": "パスワードの一致："
      },
      "job_search": {
        "no_search_condition": "検索条件なし",
        "search_condition": "検索条件：",
        "header_title": "求人情報検索 | ",
        "all": "すべて"
      },
      "company_search": {},
      "favorite": {
        "alert_hidden": "気になるを非表示にしました。"
      },
      "load_more": {
        "close_more": "閉じる"
      }
    }
  }
}
